import { View } from '@/styles/reactnative';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CButton } from '../../../../../../components/Common';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import CrossModalFooter from './CrossModalFooter';
import CrossModalHeader from './CrossModalHeader';
import CrossSliderBar from './CrossSliderBar';
import { CrossModalDescriptionBox } from './styles';
import { useIsMobile } from '@/utils/CalVW';
import styled from 'styled-components';

interface CrossModalContentProps {
  closeModal: () => void;
  initialCrossIso?: string;
  initialLeverage?: number;
}

const CROSS = 'cross';
const ISO = 'iso';
const tabs = [CROSS, ISO];

const CrossModalContent = ({
  closeModal,
  initialCrossIso,
  initialLeverage
}: CrossModalContentProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { data: tradeStore } = useTradeStore();

  const [tab, setTab] = useState(initialCrossIso === 'C' ? CROSS : ISO);
  const [leverage, setLeverage] = useState(initialLeverage ?? 1);

  return (
    <>
      <CrossModalHeader closeModal={closeModal} />
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          gap: isMobile ? 6 : 8,
        }}
      >
        {tabs?.map((item, index) => (
          <CButton
            key={index.toString()}
            title={item && t(item)}
            onClick={() => setTab(item)}
            style={{
              background: item === tab ? '#07D993' : '#2a2c2e',
              border: 'none',
              height: isMobile ? 32 : 36,
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              color: item === tab ? '#0d1117' : '#777986',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: isMobile ? 12 : 14,
              fontWeight: 700,
              letterSpacing: '-0.42px',
              fontFamily: 'NanumSquareRound'
            }}
          />
        ))}
      </View>

      <View style={{ width: '100%', marginTop: isMobile ? 20 : 30 }}>
        <CrossSliderBar
          leverage={leverage}
          setLeverage={setLeverage}
          maxLeverage={tradeStore.max_leverage}
        />
        <CrossModalDescriptionBox>
          <CustomText
            style={{
              fontSize: 12,
              lineHeight: '1.5',
              fontWeight: 400,
              color: '#b3b5bd',
              letterSpacing: '-0.36px'
            }}
          >
            {tab === CROSS
              ? t('crossModalDescription')
              : t('isoModalDescription')}
          </CustomText>
        </CrossModalDescriptionBox>

        <CrossModalFooter
          ep_id={tradeStore.ep_id}
          cross_iso={tab === CROSS ? 'C' : 'I'}
          leverage={leverage}
          closeModal={closeModal}
        />
      </View>
    </>
  );
};

export default React.memo(CrossModalContent);

const CustomText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-family: 'NanumSquareRound', sans-serif !important;
  color: #fff;
`;
